"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const BarChartIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M3.281 30A3.297 3.297 0 0 1 0 26.719V12.656c0-1.8 1.481-3.281 3.281-3.281s3.281 1.481 3.281 3.281v14.063c0 1.8-1.481 3.281-3.281 3.281ZM15 30a3.297 3.297 0 0 1-3.281-3.281V3.281A3.296 3.296 0 0 1 15 .001c.869 0 1.704.346 2.319.96a3.16 3.16 0 0 1 .961 2.32v23.438c0 1.8-1.48 3.28-3.28 3.281Zm11.719 0a3.297 3.297 0 0 1-3.281-3.281v-6.563c0-1.8 1.481-3.281 3.281-3.281S30 18.356 30 20.156v6.563c0 1.8-1.481 3.281-3.281 3.281Z",
    fill: color
  })]
});

BarChartIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = BarChartIcon;
exports.default = _default;